@if(loading){
  <div class="position-absolute w-100 h-100 d-flex flex-column align-items-center bg-white justify-content-center">
    <mat-spinner></mat-spinner>
  </div>
}@else{
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title><h2>Empresas</h2></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div id="fieldsContainer">
        <mat-accordion class="iconTitle" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>find_in_page</mat-icon>Busqueda Avanzada
              </mat-panel-title>
            </mat-expansion-panel-header>
            <br>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Nombre</mat-label>
                  <input matInput>
                  <mat-icon matSuffix>person</mat-icon>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>RFC</mat-label>
                  <input matInput>
                  <mat-icon matSuffix>document_scanner</mat-icon>
                </mat-form-field>
              </div>
            </div>
            <div id="buttonContainer">
              <button mat-flat-button class="button">
                <mat-icon>search</mat-icon>Consultar
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <br>
      <!--div class="formControl">
        <div class="control">
          <button mat-flat-button class="button buttonWidth" (click)="onShowAgregar()">
            Agregar
          </button>
        </div>
      </div>
      <br-->
      <div id="tableContainer">
        <app-table #companiesTable  
                    (paginatorEvent)="paginatorEvent($event)"
                    (editEvent)="editEvent($event)"
                    [tableModel]="tableModel">
        </app-table>
                    <!-- (deleteEvent)="deleteEvent($event)" -->
      </div>
    </mat-card-content>
  </mat-card>
}